export function processorNameToInfoProviders(infoProvider) {
    switch (infoProvider) {
        case 'amex': {
            return ['amex', 'amex_regular', 'amex_api'];
        }
        case 'cabal': {
            return ['cabal', 'cabal_regular'];
        }
        case 'centrocard': {
            return ['centrocard_regular', 'centrocard'];
        }
        case 'first_data': {
            return [
                'first_data',
                'first_data_new',
                'first_data_old',
                'first_data_regular',
                'first_data_sftp'
            ];
        }
        case 'naranja': {
            return ['naranja', 'naranja_regular'];
        }
        case 'nevada': {
            return ['nevada', 'nevada_regular'];
        }
        case 'prisma': {
            return ['prisma', 'prisma_regular', 'visa'];
        }
        default:
            return [infoProvider];
    }
}
